var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useContext, useEffect, useMemo } from 'react';
import { Skeleton } from '@material-ui/lab';
import { Box, Button, Typography } from '@kareo/design-system';
import { DateTime } from 'luxon';
import { getPatientAppointments } from 'shared-assets/facesheet-ui/service/facesheet/service';
import rollbar from 'shared-assets/src/errors/errors';
import { appointmentStatusIds } from 'shared-assets/facesheet-ui/service/facesheet/constants';
import { TimezoneContext } from '../Container/Facesheet';
import { CACHED_DATA_STATUS_CODE, DATE_CACHED_HTTP_HEADER, } from '../../../service/facesheet/types';
var AppointmentInfo = function (_a) {
    var patient = _a.patient, apptInfoFunctions = _a.apptInfoFunctions, nextApptInfo = _a.nextApptInfo, lastApptInfo = _a.lastApptInfo, loadingApptInfo = _a.loadingApptInfo, lastApptInfoError = _a.lastApptInfoError;
    var timeZone = useContext(TimezoneContext);
    var dateTimeString = function (millis) {
        var dt = DateTime.fromMillis(millis, { zone: timeZone });
        return dt.toLocaleString(DateTime.DATE_SHORT) + " at " + dt.toLocaleString(DateTime.TIME_SIMPLE);
    };
    var setLastApptInfo = apptInfoFunctions.setLastApptInfo;
    var setNextApptInfo = apptInfoFunctions.setNextApptInfo;
    var setLoadingApptInfo = apptInfoFunctions.setLoadingApptInfo;
    var setLastApptInfoError = apptInfoFunctions.setLastApptInfoError;
    var fetchApptInfo = function (patientId) { return __awaiter(void 0, void 0, void 0, function () {
        var patientAppointmentsResponse, responseCachedDate, contentType, patientAppointments, lastAppointment_1, apptStatus, appointmentReason, nextAppointment_1, apptStatus, redirectUrl, appointmentUiUrl, appointmentReason;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getPatientAppointments(patientId)];
                case 1:
                    patientAppointmentsResponse = _a.sent();
                    if (!(patientAppointmentsResponse === null || patientAppointmentsResponse === void 0 ? void 0 : patientAppointmentsResponse.ok)) return [3 /*break*/, 4];
                    if ((patientAppointmentsResponse === null || patientAppointmentsResponse === void 0 ? void 0 : patientAppointmentsResponse.status) === CACHED_DATA_STATUS_CODE) {
                        responseCachedDate = patientAppointmentsResponse.headers.get(DATE_CACHED_HTTP_HEADER);
                        if (responseCachedDate) {
                            apptInfoFunctions.setCacheDate(responseCachedDate);
                        }
                    }
                    contentType = patientAppointmentsResponse.headers.get('content-type');
                    if (!(contentType && contentType.startsWith('application/json'))) return [3 /*break*/, 3];
                    return [4 /*yield*/, patientAppointmentsResponse.json()];
                case 2:
                    patientAppointments = _a.sent();
                    if (patientAppointments) {
                        lastAppointment_1 = patientAppointments.appointmentLast;
                        if (lastAppointment_1) {
                            apptStatus = appointmentStatusIds[lastAppointment_1.appointmentStatus];
                            appointmentReason = patientAppointments.appointmentReasonLast
                                ? "(" + patientAppointments.appointmentReasonLast.name + ")"
                                : '';
                            setLastApptInfo({
                                reason: appointmentReason,
                                status: apptStatus.status,
                                color: apptStatus.color,
                                time: dateTimeString(lastAppointment_1.startTime),
                                editApptUrl: '',
                            });
                        }
                        nextAppointment_1 = patientAppointments.appointmentNext;
                        if (nextAppointment_1) {
                            apptStatus = appointmentStatusIds[nextAppointment_1.appointmentStatus];
                            redirectUrl = encodeURIComponent("/facesheet-ui/api/viewFacesheet/patient/" + patientId);
                            appointmentUiUrl = "/appointment-ui/#/?guid=" + nextAppointment_1.appointmentUUID + "&redirectUrl=" + redirectUrl;
                            if (nextAppointment_1.occurrenceId) {
                                appointmentUiUrl += "&occurrenceId=" + nextAppointment_1.occurrenceId;
                            }
                            appointmentReason = patientAppointments.appointmentReasonNext
                                ? "(" + patientAppointments.appointmentReasonNext.name + ")"
                                : '';
                            setNextApptInfo({
                                reason: appointmentReason,
                                status: apptStatus.status,
                                color: apptStatus.color,
                                time: dateTimeString(nextAppointment_1.startTime),
                                editApptUrl: appointmentUiUrl,
                            });
                        }
                    }
                    _a.label = 3;
                case 3: return [3 /*break*/, 5];
                case 4:
                    setLastApptInfoError(true);
                    _a.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var lastAppointment = useMemo(function () {
        if (loadingApptInfo) {
            return React.createElement(Skeleton, { variant: "text", width: "8rem" });
        }
        if (lastApptInfo) {
            return (React.createElement(Typography, { variant: "body1", component: "div", color: "textSecondary" }, lastApptInfo.time + " " + lastApptInfo.reason + " - ",
                React.createElement(Typography, { component: "span", style: { color: lastApptInfo.color } }, lastApptInfo.status)));
        }
        else {
            return (React.createElement(Typography, { variant: "body1", component: "div", color: "textPrimary" }, lastApptInfoError ? '-' : 'None'));
        }
    }, [loadingApptInfo]);
    var nextAppointment = useMemo(function () {
        if (loadingApptInfo) {
            return React.createElement(Skeleton, { variant: "text", width: "8rem" });
        }
        if (nextApptInfo) {
            return (React.createElement(Box, null,
                React.createElement(Button, { variant: "text", color: "vitality", onClick: function () { return window.open(nextApptInfo.editApptUrl, '_self'); }, style: { paddingLeft: '0px', paddingRight: '2px' } }, nextApptInfo.time + " " + nextApptInfo.reason + " - "),
                React.createElement(Typography, { component: "span", style: { color: nextApptInfo.color } }, nextApptInfo.status)));
        }
        else {
            return (React.createElement(Typography, { variant: "body1", component: "div", color: "textPrimary" }, lastApptInfoError ? '-' : 'None'));
        }
    }, [loadingApptInfo]);
    useEffect(function () {
        // Using the loadingApptInfo flag to prevent requesting the information
        // every time a user opens the baseball card
        if (patient && patient.patientId && loadingApptInfo) {
            fetchApptInfo(patient.patientId)
                .catch(function (error) {
                setLastApptInfoError(true);
                rollbar.error(error);
            })
                .finally(function () {
                setLoadingApptInfo(false);
            });
        }
    }, [patient.patientId]);
    return (React.createElement(Box, null,
        React.createElement(Typography, { variant: "h4", component: "div" }, "Last Appointment"),
        lastAppointment,
        React.createElement("br", null),
        React.createElement(Typography, { variant: "h4", component: "div" }, "Next Appointment"),
        nextAppointment));
};
export default AppointmentInfo;
